export let Terms;
(function (Terms) {
  Terms["Products"] = "products";
  Terms["Posts"] = "posts";
  Terms["ProductCategories"] = "productCategories";
  Terms["Pages"] = "pages";
})(Terms || (Terms = {}));